import angular from 'angular'
import template from './template.html'

function NominasCfdiComponent($filter, $location, $moment, NominasCfdiEmpresas, NominasCfdiEmpresa) {
  let $ctrl = this;
  $ctrl.$onChanges = $onChanges;
  $ctrl.$onInit = $onInit;
  $ctrl.buscar = buscar;
  $ctrl.seleccionar = seleccionar;

  $ctrl.NominasCfdiEmpresas = NominasCfdiEmpresas;
  $ctrl.NominasCfdiEmpresa = NominasCfdiEmpresa;
  $ctrl.catalogos = {};
  $ctrl.$filterOrderBy = $filter('orderBy');
  $ctrl.seleccion = [];

  function $onChanges(changes) {
    if (changes.fechaInicial && !angular.isDate($ctrl.fechaInicial)) {
      $ctrl.fechaInicial = $moment().startOf('month').toDate();
    }

    if (changes.fechaFinal && !angular.isDate($ctrl.fechaFinal)) {
      $ctrl.fechaFinal = $moment().endOf('month').toDate();
    }

    cargar();
  }

  function $onInit() {
    $ctrl.promise = $ctrl.NominasCfdiEmpresas.get()
      .then(function (response) {
        $ctrl.catalogos.empresas = $ctrl.$filterOrderBy(response.data, 'descripcion');
      });
  }

  function buscar() {
    $location.search({
      id_empresa: $ctrl.idEmpresa,
      fecha_inicial: $filter('date')($ctrl.fechaInicial, 'yyyy-MM-dd'),
      fecha_final: $filter('date')($ctrl.fechaFinal, 'yyyy-MM-dd'),
    });

    cargar();
  }

  function cargar() {
    $ctrl.data = undefined;

    if ($ctrl.idEmpresa && $ctrl.fechaInicial && $ctrl.fechaFinal) {
      $ctrl.NominasCfdiEmpresa.get($ctrl.idEmpresa, $ctrl.fechaInicial, $ctrl.fechaFinal)
        .then(function (response) {
          $ctrl.data = response.data
        });
    }
  }

  function seleccionar(data) {
    $ctrl.seleccion = data;
  }
}

angular.module('nominas.cfdi')
  .component('nominasCfdi', {
    template: template,
    controller: NominasCfdiComponent,
    bindings: {
      idEmpresa: '<',
      fechaInicial: '<',
      fechaFinal: '<',
    },
  });



// WEBPACK FOOTER //
// ./src/nominas/cfdi/components/controller.js